
import * as angular from 'angular';
import { DiscountForStaffService } from '../discount-for-staff.service';

class DiscountForStaffSpecialTab implements ng.IController {

    public static $inject = ['discountForStaffService'];

    constructor(
        public discountForStaffService: DiscountForStaffService
    ) {}

    public $onDestroy() {
        this.discountForStaffService.deleteAccessKey();
    }

}

angular.module('naut').component('discountForStaffSpecialTab', {
    template: require('./discount-for-staff-special-tab.component.html'),
    controller: DiscountForStaffSpecialTab,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/discountForStaff/special-tab/discount-for-staff-special-tab.component.ts